import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-6" data-testid="access-denied-page">
      <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-5">
        <ShieldOff size={32} className="text-red-400" />
      </div>
      <h2 className="text-xl font-bold text-gray-800 mb-2">Access Denied</h2>
      <p className="text-sm text-gray-500 max-w-sm mb-6">
        You don't have permission to view this page. Contact your administrator to request access.
      </p>
      <button
        onClick={() => navigate('/hotel-onboarded')}
        className="flex items-center gap-2 px-5 py-2.5 bg-teal-600 text-white text-sm font-semibold rounded-xl hover:bg-teal-700 transition-colors"
        data-testid="access-denied-back-btn"
      >
        <ArrowLeft size={16} /> Go to Home
      </button>
    </div>
  );
};

export default AccessDenied;
